import Images from './images';
import MiniGames from './minigames';

export const NewGamesPosters = [
  {
    bgImgSrc: Images.fantasyCricketPosterBg,
    titleImgSrc: Images.fantasyCricketPosterTitle,
    gameImgSrc: Images.fantasyCricketPosterGameImg,
    game: 'cricket',
    gameDescription1: 'Build your team & dominate',
    gameDescription2: 'the pitch in Fantasy Cricket!'
  },
  {
    bgImgSrc: Images.pokerPosterBg,
    titleImgSrc: Images.pokerPosterTitle,
    gameImgSrc: Images.pokerPosterGameImg,
    game: 'poker',
    gameDescription1: 'Play your cards right & ',
    gameDescription2: 'hit the jackpot in Poker!'
  },
  {
    bgImgSrc: Images.fantasyFootballPosterBg,
    titleImgSrc: Images.fantasyFootballPosterTitle,
    gameImgSrc: Images.fantasyFootballPosterGameImg,
    game: 'football',
    gameDescription1: 'Draft your ultimate team &',
    gameDescription2: 'score big in Fantasy Football!'
  },
  {
    bgImgSrc: Images.yesNoFantasyPosterBg,
    titleImgSrc: Images.yesNoFantasyPosterTitle,
    gameImgSrc: Images.yesNoFantasyPosterGameImg,
    game: 'yesorno',
    gameDescription1: 'Predict Yes/No',
    gameDescription2: 'and WIN BIG!'
  },
  {
    gameName: 'LeaderBoard Games',
    gameImage: Images.fantasyCricketImg,
    gameBackgroundImgUrl: Images.leaderBoardGameBg,
    contest: {
      filledTeamSlots: '15,765'
    },
    bgImgSrc: Images.leaderBoardGameBg,
    titleImgSrc: Images.leaderBoardGameTitle,
    gameImgSrc: Images.leaderBoardGameimg,
    game: 'leaderboard',
    gameDescription1: 'Compete with the best & ',
    gameDescription2: 'become the ultimate champion!'
  },
  {
    gameName: 'Pvp Games',
    gameImage: Images.fantasyCricketImg,
    gameBackgroundImgUrl: Images.pvpGameBg,
    contest: {
      filledTeamSlots: '15,765'
    },
    bgImgSrc: Images.pvpGameBg,
    titleImgSrc: Images.pvpGameTitle,
    gameImgSrc: Images.pvpGameimg,
    game: 'pvp',
    gameDescription1: 'Compete against other players & ',
    gameDescription2: 'conquer the competition!'
  }
];
export const cardGamesPoster = [
  {
    bgImgSrc: Images.pokerPosterBg,
    titleImgSrc: Images.pokerPosterTitle,
    gameImgSrc: Images.pokerPosterGameImg,
    game: 'poker',
    gameDescription1: 'Play your cards right ',
    gameDescription2: 'hit the jackpot in poker!'
  }
];
export const QuizGamesPoster = [
  {
    bgImgSrc: Images.numberSnakePosterBg,
    titleImgSrc: Images.numberSnakePosterTitle,
    gameImgSrc: Images.numberSnakePosterGameImg,
    game: 'numberSnake',
    gameData: MiniGames.numberSnake,
    gameType: 'minigame',
    gameDescription1: 'Slither your way to high scores',
    gameDescription2: 'in the Number Snake puzzle!'
  },
  {
    bgImgSrc: Images.quickMathsPosterBg,
    titleImgSrc: Images.quickMathsPosterTitle,
    gameImgSrc: Images.quickMathsPosterGameImg,
    game: 'quickMaths',
    gameData: MiniGames.quickMaths,
    gameType: 'minigame',
    gameDescription1: 'Sharpen your mind & improve',
    gameDescription2: ' your math skills with Quick Math!'
  }
];

export const sportsGamePoster = [
  {
    bgImgSrc: Images.cricketBatterPosterBg,
    titleImgSrc: Images.cricketBatterPosterTitle,
    gameImgSrc: Images.cricketBatterPosterGameImg,
    game: MiniGames.cricketBatterChallenge.gameName,
    gameData: MiniGames.cricketBatterChallenge,
    gameType: 'minigame',
    gameDescription1: 'Step up to the crease &',
    gameDescription2: 'become a cricket champion!'
  },
  {
    bgImgSrc: Images.lastWicketPosterBg,
    titleImgSrc: Images.lastWicketPosterTitle,
    gameImgSrc: Images.lastWicketPosterGameImg,
    game: MiniGames.lastWicket.gameName,
    gameData: MiniGames.lastWicket,
    gameType: 'minigame',
    gameDescription1: 'Protect your wicket & score',
    gameDescription2: 'big in Last Wicket cricket game!'
  },

  {
    bgImgSrc: Images.penaltyKickPosterPosterBg,
    titleImgSrc: Images.penaltyKickPosterPosterTitle,
    gameImgSrc: Images.penaltyKickPosterPosterGameImg,
    game: MiniGames.penaltyKicks.gameName,
    gameData: MiniGames.penaltyKicks,
    gameType: 'minigame',
    gameDescription1: 'Score the winning goal in Penalty',
    gameDescription2: 'and become a soccer legend!'
  }
];

export const arcadeGamesPoster = [
  {
    bgImgSrc: Images.smallArcherPosterBg,
    titleImgSrc: Images.smallArcherPosterTitle,
    gameImgSrc: Images.smallArcherPosterGameImg,
    game: MiniGames.smallArcher.gameName,
    gameData: MiniGames.smallArcher,
    gameType: 'minigame',
    gameDescription1: 'Test your aim and precision',
    gameDescription2: 'in the Small Archer adventure!'
  },

  {
    bgImgSrc: Images.fruitDynastyPosterBg,
    titleImgSrc: Images.fruitDynastyPosterTitle,
    gameImgSrc: Images.fruitDynastyPosterGameImg,
    game: MiniGames.fruitDynasty.gameName,
    gameData: MiniGames.fruitDynasty,
    gameType: 'minigame',
    gameDescription1: 'Rule the fruit kingdom ',
    gameDescription2: 'in Fruit Dynasty'
  }
];

export const puzzleGamesPoster = [
  {
    bgImgSrc: Images.boxTowerPosterBg,
    titleImgSrc: Images.boxTowerPosterTitle,
    gameImgSrc: Images.boxTowerPosterGameImg,
    game: MiniGames.boxTower.gameName,
    gameData: MiniGames.boxTower,
    gameType: 'minigame',
    gameDescription1: 'Rise to the top ',
    gameDescription2: 'in Box Tower!'
  },
  {
    bgImgSrc: Images.popUpPosterBg,
    titleImgSrc: Images.popUpPosterTitle,
    gameImgSrc: Images.popUpPosterGameImg,
    game: MiniGames.popUp.gameName,
    gameData: MiniGames.popUp,
    gameType: 'minigame',
    gameDescription1: 'Pop your way ',
    gameDescription2: 'to the top!'
  },

  {
    bgImgSrc: Images.smashTheRockPosterBg,
    titleImgSrc: Images.smashTheRockPosterTitle,
    gameImgSrc: Images.smashTheRockPosterGameImg,
    game: MiniGames.smashTheRock.gameName,
    gameData: MiniGames.smashTheRock,
    gameType: 'minigame',
    gameDescription1: 'Crush the competition',
    gameDescription2: 'in Smash the Rock!'
  }
];
export const racingGamesPoster = [
  {
    bgImgSrc: Images.carRacePosterBg,
    titleImgSrc: Images.carRacePosterTitle,
    gameImgSrc: Images.carRacePosterGameImg,
    game: MiniGames.carRace.gameName,
    gameData: MiniGames.carRace,
    gameType: 'minigame',
    gameDescription1: 'Speed to the finish line &',
    gameDescription2: 'become a champion of the track'
  }
];
